shvenergy._404 = (function ($) {
    "use strict";

    function init() {
        if (window.trackingVariables && window.trackingVariables.type === 'Error page') {
            let thisUrl = window.location.href,
                referrerUrl = document.referrer;

            shvenergy.tracking.trackRawEventData({
                'event': 'displayErrorPage',
                'errorCode': '404',
                'urlError': thisUrl,
                'referrerUrl': referrerUrl
            });
        }
    }
    $(function() {
        init();
    });

})(jQuery);